// packages/frontend/core/src/modules/theme/use-theme.ts
import { atom, useAtom } from 'jotai';
import { THEME_PRESETS, type ThemeConfig } from './theme-config';

const currentThemeAtom = atom<ThemeConfig>(THEME_PRESETS[0]);

export const useTheme = () => {
  const [currentTheme, setCurrentTheme] = useAtom(currentThemeAtom);

  const changeTheme = (themeId: string) => {
    const theme = THEME_PRESETS.find(t => t.id === themeId);
    if (theme) {
      setCurrentTheme(theme);
      // 保存到本地存储
      localStorage.setItem('affine-theme', themeId);
    }
  };

  return {
    currentTheme,
    availableThemes: THEME_PRESETS,
    changeTheme,
  };
};
